export default __webpack_public_path__ + "static/media/dice-5.259a7cfc.svg";